import { useEffect, useState } from "react";
import SideNavLayout from "../../customsidenav/sidenavlayout";
import { HumanIcon, PrivilagesIcon, arrowleft } from "../../utils/svgs/svgcode";
import ProfileCard from "./ProfileCard";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../api/api"; // Adjust path as needed
import PrivilagesView from "./Privilages";
import ToastMessage from "../../blinkscribe/modals/simplealert";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import { getPracticeId } from "../../config/practice";
import { profilePhotoObjectUrl } from "../../api/profilePhoto";

const ManageProfile = () => {
  const [view, setView] = useState(0);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState("");
  const userConfig = useSelector((state) => state.userconfig);
  const [severity, setSeverity] = useState("success");
  const [privileges, setPrivileges] = useState([]);
  const [imgdata, setimgdata] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const dispatch=useDispatch()
  const tabs = [
    { id: 0, label: "Account", icon: HumanIcon },
    { id: 1, label: "Privileges", icon: PrivilagesIcon },
  ];
  const practiseid = getPracticeId();
  // Fetch privileges data
  const fetchPriviData = async (skipload) => {
    if (!skipload) {
      setLoading(true);
    }

    try {
      const response = await api.get(`/v1/${practiseid}/privileges/get`);
      if (response.status === 200) {
        setPrivileges(response.data); // Update state with privileges data
      } else {
        setPrivileges([]); // Empty privileges if no data is found
      }
    } catch (error) {
      console.error(error); // Log any errors
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const fetchuser = async (skipload) => {
    try {
      if (!skipload) {
        setLoading(true);
      }

      const response = await api.get("/auth/me");
      setUser(response);

      // Only an image answer becomes the photo (api/profilePhoto.js); without one
      // ProfileCard shows the initials instead of a broken image.
      const photoUrl = await profilePhotoObjectUrl(practiseid, response.id);
      setimgdata(photoUrl || "");
      dispatch(setConfig(response));
    } catch (error) {
      console.error("Error fetching user", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadimg = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const upload = await api.post(
        `/v1/${practiseid}/user/${user.id}/upload-profile-picture`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (upload.status === 200) {
setAlertMessage('Profile picture updated successfully')
setSeverity('success')
setOpen(true)

        fetchuser(true); // Refresh profile
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (view === 0) {
      fetchuser();
    } else {
      fetchPriviData();
    }
  }, [view]);

  return (
    <SideNavLayout>
      <div className="">
        <div className="flex justify-start items-center gap-3">
          {/* Back Arrow */}
          <button
            onClick={() => navigate("/landing")}
            className="inline-flex items-center justify-center w-9 h-9 rounded-[8.75px] bg-[#202224] backdrop-blur-sm"
          >
            <span className="text-white">{arrowleft}</span>
          </button>

          {/* Tabs */}
          <div className="inline-flex gap-3 p-[4px] rounded-[8.75px] border border-[#E5E7EB] bg-white shadow-md">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const selected = view === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setView(tab.id)}
                  className={`flex items-center gap-2 px-3 py-[6px] text-[13px] font-medium transition-all duration-200 rounded-[6.75px] ${
                    selected
                      ? "bg-[#1D2951] text-white shadow-md"
                      : "text-black"
                  }`}
                >
                  <span className="flex items-center justify-center w-4 h-4">
                    <Icon color={selected ? "white" : "#4A5565"} />
                  </span>
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-40">
            <div className="flex flex-col items-center justify-center h-40 text-center">
              <p className="text-base font-semibold text-gray-800">
                Loading content
              </p>
              <p className="mt-1 text-sm text-gray-500">
                {view == 0
                  ? "Please wait while we prepare your profile..."
                  : "Please wait while we getting privileges..."}
              </p>
            </div>
          </div>
        ) : view === 0 ? (
          <ProfileCard
            fetchuser={fetchuser}
            setAlertMessage={setAlertMessage}
            setOpen={setOpen}
            setSeverity={setSeverity}
            data={user}
            img={imgdata}
            onFileChange={(file) => {
              setSelectedFile(file);
                const preview = URL.createObjectURL(file);
                  setimgdata(preview); 
              uploadimg(file);
            }}
          />
        ) : (
          <PrivilagesView
            setAlertMessage={setAlertMessage}
            setOpen={setOpen}
            setSeverity={setSeverity}
            fetchPriviData={fetchPriviData}
            data={privileges}
            user={user}
          />
        )}
      </div>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handleClose}
      />

      {/* MUI Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </SideNavLayout>
  );
};

export default ManageProfile;
